import * as React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";

export const GeneralModal = (props) => {
  const {
    open,
    setOpen,
    showCloseIcon = true,
    className,
    children,
    focusTrapped = true,
    blockScroll = true,
    styles,
  } = props;
  const onCloseModal = () => {
    window.destoryReactApp();
    setOpen(false);
  };

  return (
    <Modal
      classNames={{ root: className }}
      open={open}
      onClose={onCloseModal}
      center
      showCloseIcon={showCloseIcon}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      focusTrapped={focusTrapped}
      blockScroll={blockScroll}
      styles={styles}
    >
      {children}
    </Modal>
  );
};
